<template>
    <div class="content">
      <h1>Marble Blast Ultra & Modding: From #1 Player to Game Developer</h1>

      <p>
        Marble Blast Ultra was <strong>the game</strong> that got me hooked on competitive online play. I wasn’t just good—I was
        <strong>ranked #1 online</strong> and managed to collect <strong>over 1 million gems</strong> in multiplayer battles.
        While I also cracked the <strong>top 10 in single-player</strong>, my real focus was on <strong>dominating multiplayer matches</strong>.
        Meanwhile, my brother went all-in on single-player, <strong>securing first place</strong> on multiple levels.
      </p>

      <p>
        But my involvement in Marble Blast didn't stop at just playing—I also <strong>spent years modding and building new content</strong>.
      </p>

      <h2>Marble Blast Evolved: My First Major Mod</h2>

      <p>
        Before I ever got my hands on Marble Blast Ultra’s source code, I was already working on Marble Blast Evolved, a full mod of Marble Blast Gold.
        This was my first big game mod—and where I first started experimenting with game development. <a href="https://www.youtube.com/watch?v=Fh_GgX8PRv0">Original Trailer</a>
      </p>

      <h2>Modding Marble Blast Ultra</h2>

      <p>
        Eventually, I managed to get access to Marble Blast Ultra’s source code, which changed everything.
        Alongside my brother and two other modders, we started working on something even bigger:
        a full-blown Marble Blast game of our own.
      </p>
      <p><a href="https://www.youtube.com/watch?v=Lf8t5OEDc8s">Here is a one v one showing online game play</a> Greed is the one recording and was one of the people that worked with me on the game. As we could just make up any name i kept changing them at this point, marble 36 was not available on the original game so its a bit of a joke.</p>

      <h3>What We Built</h3>

      <ul>
        <li>100+ custom single-player levels</li>
        <li>20 online multiplayer maps with leaderboards</li>
        <li>New mechanics and gameplay features</li>
        <li>Custom textures, UI changes, and more</li>
      </ul>

      <h3>The Hardest Part: Online Multiplayer</h3>

      <p>
        The toughest challenge was getting online multiplayer to work properly.
        The game wasn’t built with modern networking solutions, so we had to reverse-engineer and rebuild a lot of it ourselves.
        But after months of work, we finally got it running—and it became the base of most Marble Blast mods out there today.
      </p>

      <h2>Marble It Up: Mayhem! – A New Challenge</h2>

      <p>
        Years later, a spiritual successor, <strong>Marble It Up: Mayhem!</strong>, was released. Naturally, I jumped in to see how I stacked up
        against the new generation of players. But there was a problem: <strong>there was no overall leaderboard.</strong>
      </p>

      <p>
        For someone like me—who spent years grinding the leaderboards—this felt like a <strong>glaring oversight</strong>.
        How could you have a competitive game without a proper way to track <strong>who’s the best?</strong>
      </p>

      <p>
        So, I decided to <strong>fix it myself.</strong>
      </p>

      <h2>Building a Custom Leaderboard</h2>

      <p>
        I built a <strong>Blazor-based website</strong> to <strong>track stats from every level</strong> and create a proper <strong>global leaderboard</strong>.
        However, getting the data wasn’t as easy as I expected.
      </p>

      <h3>How I Extracted the Stats</h3>

      <ul>
        <li>
          <strong>Game Center Shenanigans</strong> – Apple’s <strong>Game Center</strong> had the mobile stats locked away, so I had to get creative.
          I set up <strong>Fiddler4</strong> on my PC, connected my iPhone, and <strong>sniffed out the API calls</strong> that were retrieving leaderboard data.
        </li>
        <li>
          <strong>Desktop Data Extraction</strong> – The PC version of the game <strong>didn’t use Game Center</strong>, but instead had a <strong>separate web server</strong> for its stats.
          So, I had to merge data from <strong>two different sources.</strong>
        </li>
        <li>
          <strong>Automating the Process</strong> – Once I figured out how to <strong>retrieve</strong> all the stats, I built a script that <strong>collected new data every hour</strong>,
          ensuring the leaderboards stayed up-to-date.
        </li>
      </ul>

      <h2>Where Is It Now?</h2>

      <p>
        The version of <strong>Marble It Up: Mayhem!</strong> that I tracked has since been <strong>removed from the Apple store</strong>,
        so I <strong>no longer update the leaderboard</strong>. However, you can still check out a <strong>snapshot from 2021</strong> at:
      </p>

      <p>
        <a href="https://marble.pittroche.co.uk/" target="_blank" class="btn">Marble Leaderboard - Click Here</a>
        look out for xIAMClassiCx this is the tag i normally use (i have many others)
      </p>

      <p>
        Even though it’s not updating anymore, it’s still fun to <strong>look back at the rankings</strong> and see where players stood before the game disappeared from Apple.
      </p>

      <hr>

      <p>
        This project was a <strong>blast to work on</strong>, and honestly, it brought back some of the same excitement I had when competing in <strong>Marble Blast Ultra</strong>.
        If <strong>Marble It Up</strong> ever brings back a global leaderboard, you can bet I’ll be there—either competing for the top or figuring out a way to <strong>track the competition myself.</strong>
      </p>
    </div>

</template>


